/**
 * AccPlus Superadmin Portal — App Router
 */

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

import IdleTimeoutWrapper from './components/IdleTimeoutWrapper';
import Login from './pages/Login';
import Layout from './pages/Layout';
import Dashboard from './pages/Dashboard';
import TenantList from './pages/TenantList';
import TenantForm from './pages/TenantForm';
import TenantDetail from './pages/TenantDetail';
import TenantHealth from './pages/TenantHealth';
import Subscriptions from './pages/Subscriptions';
import PlatformUsers from './pages/PlatformUsers';
import PlatformSettings from './pages/PlatformSettings';
import AuditLogs from './pages/AuditLogs';
import Reports from './pages/Reports';
import Migrations from './pages/Migrations';
import Backups from './pages/Backups';
import DatabaseTool from './pages/DatabaseTool';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<Login />} />

        {/* Protected — Layout with sidebar + idle timeout */}
        <Route
          path="/"
          element={
            <IdleTimeoutWrapper>
              <Layout />
            </IdleTimeoutWrapper>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="tenants" element={<TenantList />} />
          <Route path="tenants/new" element={<TenantForm />} />
          <Route path="tenants/:code" element={<TenantDetail />} />
          <Route path="tenants/:code/edit" element={<TenantForm />} />
          <Route path="subscriptions" element={<Subscriptions />} />
          <Route path="users" element={<PlatformUsers />} />
          <Route path="audit" element={<AuditLogs />} />
          <Route path="reports" element={<Reports />} />
          <Route path="migrations" element={<Migrations />} />
          <Route path="health" element={<TenantHealth />} />
          <Route path="backups" element={<Backups />} />
          <Route path="db-tool" element={<DatabaseTool />} />
          <Route path="settings" element={<PlatformSettings />} />
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
